(function () {
  function initFloatingContactSidebar(root) {
    var wechatBtn = root.querySelector("[data-fcs-wechat-btn]");
    var wechatPanel = root.querySelector("[data-fcs-wechat-panel]");

    if (!wechatBtn || !wechatPanel) return;
    if (wechatBtn.dataset.fcsInited === "true") return;

    wechatBtn.dataset.fcsInited = "true";

    if (!wechatPanel.id) {
      wechatPanel.id = "fcs-wechat-panel-" + Math.random().toString(36).slice(2, 9);
    }

    wechatBtn.setAttribute("aria-controls", wechatPanel.id);
    wechatBtn.setAttribute("aria-expanded", "false");

    function open() {
      wechatBtn.classList.add("is-open");
      wechatBtn.setAttribute("aria-expanded", "true");
    }

    function close() {
      wechatBtn.classList.remove("is-open");
      wechatBtn.setAttribute("aria-expanded", "false");
    }

    function toggle() {
      var isOpen = wechatBtn.classList.contains("is-open");
      if (isOpen) {
        close();
      } else {
        open();
      }
    }

    wechatBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggle();
    });

    document.addEventListener("click", function (e) {
      if (!root.contains(e.target)) {
        close();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        close();
      }
    });
  }

  function initAllFloatingContactSidebars(scope) {
    var container = scope || document;
    container.querySelectorAll("[data-fcs]").forEach(initFloatingContactSidebar);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAllFloatingContactSidebars(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAllFloatingContactSidebars(event.target || document);
  });
})();